import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface InfoBannerBlockProps {
  title?: string;
  description: string;
}

const InfoBannerBlock = ({ title, description }: InfoBannerBlockProps) => {
  return (
    <Card variant="infoBanner" elevation={0}>
      <Stack gap="6px">
        {title && (
          <Typography variant="label.button" className="InfoBanner-text">
            {title}
          </Typography>
        )}
        <Typography variant="body.md" className="InfoBanner-text">
          {description}
        </Typography>
      </Stack>
    </Card>
  );
};

export default InfoBannerBlock;
